import axiosConn from '../axiosConn';

// Existing Galaxy history response compatibility; View more reveals this set locally.
export const getGalaxyMessageList = (payload) => [
  payload, payload?.data, payload?.data?.data,
  payload?.messages, payload?.data?.messages, payload?.data?.data?.messages,
  payload?.galaxyMessages, payload?.data?.galaxyMessages, payload?.data?.data?.galaxyMessages,
  payload?.results, payload?.data?.results, payload?.data?.data?.results,
].find(Array.isArray) || [];

export async function fetchGalaxyMessages(galaxyId, token) {
  const response = await axiosConn.get(`galaxyMessages/${galaxyId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return getGalaxyMessageList(response.data).slice().sort((a, b) =>
    new Date(a.createdAt) - new Date(b.createdAt));
}

// HTTP and realtime can race. Persisted IDs and sender-scoped temp IDs converge.
export const reconcileGalaxyMessage = (messages, incoming) => {
  const list = Array.isArray(messages) ? messages : [];
  const matches = (message) =>
    (incoming._id && message._id === incoming._id) ||
    (message.isPending && incoming.tempId && message.tempId === incoming.tempId &&
      message.senderId === incoming.senderId);
  const index = list.findIndex(matches);
  if (index < 0) return [...list, incoming];
  return list.flatMap((message, i) =>
    i === index ? [{ ...message, ...incoming }] : matches(message) ? [] : [message]);
};
